import {
	BackdropCircularProgress,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import React, { useState } from "react";

import { AuthService } from "../../services";
import { Grid } from "@mui/material";
import {
	INITIAL_SNACKBAR_DATA,
} from "../../common/constants";
import { SecurityQuestionsScreenToolbar } from "./SecurityQuestionsScreenToolbar";
import { SecurityQuestionsScreenValidationSchema } from "./validator";
import { SecurityQuestionsSetupFieldsPanel } from "./Panels/SecurityQuestionsSetupFieldsPanel";
import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

export interface ISecurityQuestionsScreen { }
export const SecurityQuestionsScreen: React.FC<ISecurityQuestionsScreen> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const accessToken = localStorage.getItem("accessToken");

	const { isPending: isSubmitting, mutate: saveSecurityQuestionsFieldsData } =
		useMutation({
			mutationFn: AuthService.saveSecurityQuestions,
			onSuccess: (res: IServerError | IResponse | any) => {
				if (res.status === 200 || res.status === 201) {
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					navigate("/auth-selection-screen")
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const DEFAULT_VALUES = {
		questionOne: undefined,
		questionTwo: undefined,
		questionThree: undefined,
		answerOne: undefined,
		answerTwo: undefined,
		answerThree: undefined,
	};

	const formMethods = useForm<any>({
		resolver: yupResolver(SecurityQuestionsScreenValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const onSubmit = (values: any) => {
		let payload = {
			accessToken: accessToken,
			questionOne: values.questionOne,
			questionTwo: values.questionTwo,
			questionThree: values.questionThree,
			answerOne: values.answerOne,
			answerTwo: values.answerTwo,
			answerThree: values.answerThree,
		};
		saveSecurityQuestionsFieldsData(payload);
	};

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	return (
		<Grid>
			<BackdropCircularProgress
				open={isSubmitting}
				testId="yooo"
			/>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"Answer the Questions"}
			</div>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="Answer Any 3 Questions"
										testId={`answer-any-three-question`}
										variant="outlined"
									// topPadding={2}
									>
										<SecurityQuestionsSetupFieldsPanel />
									</StandardPanel>
								}
								toolbar={
									<SecurityQuestionsScreenToolbar
										isSubmitting={false}
									/>
								}
								showFullDiaplay={true}
								toolbarPosition="bottom"
								testId="form-layout"
							/>
						</Grid>
					</Grid>
				</form>
			</FormProvider>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"security-questions-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
